import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FeatureToggleService {

    public features: Array<any> = null;
    private username = null;

    constructor(
        private http: HttpClient
    ) {
    }

    getFeaturesByUsername(username, renewFeatures? : boolean) {
        if (username === this.username && this.features && !renewFeatures) {
            return of(this.features);
        }
        else {
            this.username = username;
            return this.http.get(`${environment.server.api.portalpas}/FeatureToggle`).pipe(
                tap((response: any) => {
                    this.features = response;
                }),
                catchError(() => {
                    return of([]); 
                })
            );
        }
    }
}